import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Box, Typography, Button } from '@mui/material'
import { useAuth } from '../../api/context/UserAuthContext'
import { Navbar } from './Navbar'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export const PrivateRoute = ({ children, permission }) => {
  const { user, isLoading, isAuthorized } = useAuth()

  const userPermission = user?.permission

  useEffect(() => {
    if (!isLoading) {
      if (user) {
        console.log('is logged in')
      } else {
        window.location = '/login'
        console.log('not logged in')
      }
    }
  }, [user, isLoading])

  if (!user) {
    return null
  }

  if (!isAuthorized) {
    return (
      <>
        <Navbar />
        <Box
          boxSizing='border-box'
          m='auto'
          width='100%'
          maxWidth={500}
          mt={10}
          mb={10}
          border='1px solid #808080'
          p={{ xs: '30px', md: '65px' }}
          borderRadius={4}
          bgcolor='#fff'
        >
          <Box display='flex' flexDirection='row' alignItems='center'>
            <ErrorOutlineIcon style={{ color: 'red', fontSize: '32px' }} />
            <Typography variant='h2'>Access denied</Typography>
          </Box>
          <Typography variant='h5'>You have no access to this application</Typography>
        </Box>
      </>
    )
  }

  if (permission && !userPermission.includes(permission)) {
    return (
      <>
        <Navbar />
        <Box
          boxSizing='border-box'
          m='auto'
          width='100%'
          maxWidth={500}
          mt={10}
          mb={10}
          border='1px solid #808080'
          p={{ xs: '30px', md: '65px' }}
          borderRadius={4}
          bgcolor='#fff'
        >
          <Box display='flex' flexDirection='row' alignItems='center'>
            <ErrorOutlineIcon style={{ color: 'red', fontSize: '32px' }} />
            <Typography variant='h2'>Access denied</Typography>
          </Box>
          <Link to='/' style={{ color: '#000' }}>
            <Button style={{ color: '#000' }}>Return to hompage</Button>
          </Link>
        </Box>
      </>
    )
  }

  return <>{children}</>
}
